/******/ (() => {
  // webpackBootstrap
  /* eslint-disable */
  if (!customElements.get("product-quick-buy")) {
    customElements.define(
      "product-quick-buy",
      class ProductQuickBuy extends HTMLElement {
        constructor() {
          super();
          this.dataCache = new Map(); // Cache for pre-fetched data
          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.init();
        }

        init() {
          this.cacheDOMElements();
          this.bindEventHandlers();
        }

        cacheDOMElements() {
          /* ===== Cache any information that we'll need later ===== */
          this.sectionId = this.getAttribute("data-section-id");
          this.originalSectionId = this.getAttribute(
            "data-original-section-id"
          );
          this.isQuickView = this.dataset.quickView === "true";
          this.productForm = this.querySelector("product-form");
          this.stickyContainer = this.classList.contains("product-sticky")
            ? this
            : null;
          this.stickyHeader = document.querySelector(".header-section");
          this.enableURLUpdate = this.dataset.enableUrlUpdate === "true";
          this.mainProductURL = this.dataset.url;
          this.isGridItem = this.dataset.isGridItem === "true";
          this.wording = this.dataset.wordingAddToCart;
          this.openQuickBuy = this.querySelector(".quickAddJs");
          this.closeQuickBuy = this.querySelector(".quickAddCloseJs");
          this.colorIds = this.getAttribute("data-color-ids");
        }

        connectedCallback() {
          /* ===== Gather options for the current variant, handle sticky form offset, attach event listeners ===== */
          this.setStickyOffset();
          this.attachEventListeners();
          this.isCombinedListing = this.dataset.isCombinedListing === "true";
        }

        disconnectedCallback() {
          /* ===== Clean up event listeners ===== */
          this.removeEventListeners();
        }

        bindEventHandlers() {
          /* ===== Bind methods to maintain the 'this' context ===== */
          this.resizeHandler = this.handleResize.bind(this);
          this.onQuantityChange = this.handleQuantityChange.bind(this);
          this.onVariantChange = this.handleVariantChange.bind(this);
          this.prefetchVariantData = this.prefetchVariantData.bind(this);
        }

        attachEventListeners() {
          // On resize we need to update the sticky form offset
          window.addEventListener("resize", this.resizeHandler);
          // Listen for quantity changes
          eventBus.on("qty:change", this.onQuantityChange);
          // Listen for variant changes
          eventBus.on("variant:change", this.onVariantChange);
          eventBus.on("cart:added", this.closeQuickBuyModal.bind(this));
          eventBus.on("cart:added", this.openAsideCart.bind(this));
          if (this.openQuickBuy) {
            this.openQuickBuy.addEventListener(
              "click",
              this.openQuickBuyModal.bind(this)
            );
          }
          if (this.closeQuickBuy) {
            this.closeQuickBuy.addEventListener(
              "click",
              this.closeQuickBuyModal.bind(this)
            );
          }
          // Prefetch variant data
          //this.addEventListener('mouseover', this.prefetchVariantData);
          //this.addEventListener('touchstart', this.prefetchVariantData);
        }

        removeEventListeners() {
          /* ===== Remove any event listeners we've attached ===== */
          window.removeEventListener("resize", this.resizeHandler);
          eventBus.off("qty:change", this.onQuantityChange);
          eventBus.off("variant:change", this.onVariantChange);
          eventBus.off("cart:added", this.closeQuickBuyModal.bind(this));
          if (this.openQuickBuy) {
            this.openQuickBuy.removeEventListener(
              "click",
              this.openQuickBuyModal.bind(this)
            );
          }
          if (this.closeQuickBuy) {
            this.closeQuickBuy.removeEventListener(
              "click",
              this.closeQuickBuyModal.bind(this)
            );
          }
          //this.removeEventListener('mouseover', this.prefetchVariantData);
          //this.removeEventListener('touchstart', this.prefetchVariantData);
        }

        openQuickBuyModal() {
          const wrapper = this.querySelector(
            ".product-grid__quick-buy__module"
          );
          wrapper.classList.add("show");
          const parentSection = this.closest("section.shopify-section");
          const parentPage = this.closest(".page-product");
          if (parentSection) {
            parentSection.classList.add("quick-buy-open");
          }
          if (parentPage) {
            parentPage.classList.add("quick-buy-open");
          }
        }

        closeQuickBuyModal() {
          const wrapper = this.querySelector(
            ".product-grid__quick-buy__module"
          );
          wrapper.classList.remove("show");
          const parentSection = this.closest("section.shopify-section");
          const parentPage = this.closest(".page-product");
          if (parentSection) {
            parentSection.classList.remove("quick-buy-open");
          }
          if (parentPage) {
            parentPage.classList.remove("quick-buy-open");
          }
        }

        openAsideCart() {
          if (this.cart) {
            this.cart.open();
          }
        }

        prefetchVariantData() {
          const variants = this.querySelectorAll("[data-product-variant]");
          if (!variants.length) return;

          variants.forEach((variant) => {
            const productFetchUrl = variant.getAttribute(
              "data-product-fetch-url"
            );

            if (productFetchUrl && !this.dataCache.has(productFetchUrl)) {
              this.fetchProductData(productFetchUrl).catch((error) => {
                console.error(
                  `Failed to fetch data for ${productFetchUrl}:`,
                  error
                );
              });
            }
          });
        }

        async fetchProductData(productFetchUrl) {
          try {
            const response = await fetch(`${productFetchUrl}`); //&section_id=${this.originalSectionId}
            if (!response.ok) {
              throw new Error(
                `Network response was not ok for ${productFetchUrl}`
              );
            }
            const data = await response.text();
            const productData = this.extractProductData(data);
            this.dataCache.set(productFetchUrl, productData);
          } catch (error) {
            console.error(
              `Failed to fetch product data from ${productFetchUrl}:`,
              error
            );
          }
        }

        async fetchVariantData(productFetchUrl, context) {
          try {
            // Add the loader class to indicate loading state
            this.classList.add("loading");
            /* ===== Fetch the product data if it's not already cached ===== */
            // if (!this.dataCache.has(productFetchUrl)) {
            await this.fetchProductData(productFetchUrl);
            // }

            // Update the DOM with the new data
            this.updateDOMWithData(context);
          } catch (error) {
            console.error(`Failed to fetch variant data:`, error);
          } finally {
            // Remove the loader class after the operation is complete
            this.classList.remove("loading");
          }
        }

        extractProductData(data) {
          /* ===== Parse the fetched data and return the new product data ===== */
          const parser = new DOMParser();
          const htmlDocument = parser.parseFromString(data, "text/html");
          const productQuickBuy =
            htmlDocument.querySelector("product-quick-buy");
          const quickViewContent = htmlDocument.querySelector(
            "template[data-quick-view-product]"
          )?.content;

          const quickViewContentInformation =
            quickViewContent?.querySelector("product-quick-buy");

          // Inside productQuickBuy, we want to replace the <h1> element with an <a> element with the url of the product
          const productTitle = productQuickBuy.querySelector("h1");
          if (productTitle) {
            const productLink = document.createElement("a");
            productLink.href =
              productQuickBuy.getAttribute("data-url") || this.mainProductURL;
            productLink.textContent = productTitle.textContent;
            productLink.classList.add(
              "full-unstyled-link",
              "product-grid--title",
              "product-details-product-title",
              "font-semibold"
            );
            productLink.setAttribute("data-url", productLink.href);

            // Replace the h1 in productQuickBuy with the new link
            productTitle.parentNode.replaceChild(productLink, productTitle);
          }

          const productDataElement =
            this.isQuickView && quickViewContentInformation
              ? quickViewContentInformation
              : productQuickBuy;

          console.log("Extracted productQuickBuy:", productQuickBuy);
          console.log(
            "Found media-gallery:",
            htmlDocument.querySelector("media-gallery")
          );

          // Always try to extract media-gallery if it exists, regardless of context
          const productMedia = htmlDocument.querySelector("media-gallery");
          const quickViewMedia =
            quickViewContent?.querySelector("media-gallery");
          const productMediaElement =
            this.isQuickView && quickViewMedia ? quickViewMedia : productMedia;

          if (this.isCombinedListing) {
            // For combined listing pages (main product page), create a div with both media and info
            const productDiv = document.createElement("div");
            productDiv.setAttribute(
              "data-url",
              productQuickBuy?.getAttribute("data-url")
            );

            if (productMediaElement) {
              productDiv.appendChild(productMediaElement);
            }

            if (productDataElement) {
              productDiv.appendChild(productDataElement);
            }

            console.log(
              "Returning combined listing data:",
              productDiv.outerHTML
            );
            return productDiv.outerHTML;
          } else {
            // For non-combined listing pages (like featured products), return both media and info if available
            if (productMediaElement && productDataElement) {
              const productDiv = document.createElement("div");
              productDiv.setAttribute(
                "data-url",
                productQuickBuy?.getAttribute("data-url")
              );
              productDiv.appendChild(productMediaElement);
              productDiv.appendChild(productDataElement);

              console.log(
                "Returning non-combined listing data with media:",
                productDiv.outerHTML
              );
              return productDiv.outerHTML;
            } else if (productMediaElement) {
              // If only media exists, return it
              console.log(
                "Returning media gallery only:",
                productMediaElement.outerHTML
              );
              return productMediaElement.outerHTML;
            } else {
              // Fallback to product information only
              console.log(
                "Returning product information only:",
                productDataElement.outerHTML
              );
              return productDataElement.outerHTML;
            }
          }
        }

        handleResize() {
          /* ===== Handle resizing of the window ===== */
          if (window.Shopify.designMode) {
            // If we're in the theme editor we need to update the sticky form offset
            // We only do this in the editor because it's not necessary in the live site
            // because mobile devices can incorrectly trigger resize events when scrolling
            this.setStickyOffset();
          }
        }

        handleQuantityChange(event) {
          /* ===== Handle changes to the quantity input ===== */

          // Update the quantity input value
          this.productForm = this.querySelector("product-form");
          this.formQuantityInput =
            this.productForm?.querySelector('[name="quantity"]');

          if (this.formQuantityInput && event.value) {
            if (event.sectionId && event.sectionId !== this.sectionId) return;
            this.formQuantityInput.value = event.value;
          }
        }

        setStickyOffset() {
          if (this.stickyContainer && this.stickyHeader) {
            // Set the top offset of the sticky form to the height of the sticky header
            this.stickyContainer.style.top = `${this.stickyHeader.offsetHeight}px`;
          }
        }

        async handleVariantChange(context) {
          /* ===== Handle changes to the variant ===== */

          if (context.sectionId) {
            this.sectionId = context.sectionId;
          }
          if (
            context.sectionId &&
            this.colorIds.includes(this.sectionId) === true &&
            context.containerId === this.originalSectionId
          ) {
            // If the variant change was triggered by the media and the variant doesn't match
            // any of the options, we don't need to update the UI
            if (context.fromSlideChange) {
              const mediaVariantId =
                this.querySelector(
                  `[data-swatch-variant-id="${context.variant.id}"]`
                ) ||
                this.querySelector(
                  `[data-dropdown-variant-id="${context.variant.id}"]`
                );
              if (!mediaVariantId) return;
            }

            // Update the current variant based on the selected options
            this.currentVariant = context.variant;
            this.productFetchUrl = context.fetchURL;
            this.productUrl = context.productURL;

            // If we don't have a valid variant, handle it and return
            if (!this.currentVariant) {
              this.handleInvalidVariant();
              return;
            }

            if (!this.productFetchUrl || !this.productUrl) return;

            // If the variant is available, update the UI
            this.toggleAddButton(this.currentVariant.available);
            const isCached = this.dataCache.has(this.productFetchUrl);

            /*
        if (isCached && !window.Shopify.designMode) {
          this.updateDOMWithData(context);
        } else {
         */
            // If the data is not cached, fetch the product data and then update the UI
            await this.fetchVariantData(this.productFetchUrl, context);
            // }
          }
        }

        handleInvalidVariant() {
          /* ===== Handle an invalid variant ===== */
          // If the variant is invalid, disable the add to cart button
          this.toggleAddButton(false);
          // If the variant is invalid, set the add to cart button text to "unavailable"
          const addButton = this.productForm?.querySelector('[name="add"]');
          if (!addButton) return;
          const addButtonSpan = addButton.querySelector(
            "[data-add-to-cart-text]"
          );
          if (!addButtonSpan) return;

          addButtonSpan.textContent = addButtonSpan.getAttribute(
            "data-unavailable-text"
          );

          // If the variant is invalid, set the price to "Unavailable"
          const priceElement = this.querySelector("[data-product-price]");
          if (!priceElement) return;
          const priceElementSpan = priceElement.querySelector(
            "span[data-price-text]"
          );
          if (!priceElementSpan) return;

          priceElementSpan.textContent = priceElementSpan.getAttribute(
            "data-unavailable-text"
          );
        }

        updateDOMWithData(context) {
          /* ===== Update the UI with the cached data ===== */
          if (this.enableURLUpdate) this.updateURL();

          const data = this.dataCache.get(context.fetchURL);
          const html = this.parseHTML(data);
          this.updateDOM(html, context);
        }

        parseHTML(data) {
          /* ===== Parse the fetched data into a DOM object ===== */
          return new DOMParser().parseFromString(data, "text/html");
        }

        updateDOM(html, context = {}) {
          /* ===== Update the DOM with the fetched data ===== */
          this.replaceElements(html, context);

          if (context.fromSlideChange) return;

          // Emit an event to let other components know the variant was updated
          eventBus.emit("variant:updated", {
            variant: this.currentVariant,
            sectionId: this.sectionId,
            isCombinedListing: context.isCombinedListing,
            fetchURL: this.productFetchUrl,
            productURL: this.productUrl,
          });
        }

        toggleAddButton(enable) {
          /* ===== Toggle the add to cart button based on the variant availability ===== */
          const addButton = this.productForm?.querySelector('[name="add"]');
          if (addButton) {
            addButton.toggleAttribute("disabled", !enable);
          }
        }

        updateURL() {
          /* ===== Update the URL with the current variant ID ===== */
          if (this.currentVariant) {
            window.history.replaceState({}, "", `${this.productFetchUrl}`);
          }
        }

        replaceElements(html, context = {}) {
          /* ===== Replace elements in the DOM with new elements ===== */
          if (!html) return;

          console.log("Section ID:", this.sectionId);
          console.log("Color IDs:", this.colorIds);
          console.log(
            "Color IDs includes section ID:",
            this.colorIds?.includes(this.sectionId)
          );
          console.log(
            "Container ID matches original:",
            context.containerId === this.originalSectionId
          );

          if (
            this.sectionId &&
            this.colorIds.includes(this.sectionId) === true &&
            context.containerId === this.originalSectionId
          ) {
            const productQuickBuy = html.querySelector(
              `product-quick-buy[data-url="${context.productURL}"]`
            );
            if (!productQuickBuy) return;

            console.log("Context type:", context.type);
            console.log("Is grid item:", this.isGridItem);
            console.log("Context container ID:", context.containerId);
            console.log("Original section ID:", this.originalSectionId);

            if (context.type === "color") {
              if (this.isGridItem) {
                // const productWrapper = this.previousElementSibling;
                const parentCard = this.closest(".card-product");
                const productWrapper = parentCard
                  ? parentCard.querySelector(".grid-view-item-image")
                  : this.previousElementSibling;

                if (productWrapper) {
                  const productMedia = html.querySelector("media-gallery");
                  let newImages = [];

                  // Try different selectors to find images based on context
                  if (productMedia) {
                    // Try main product page structure first
                    newImages = productMedia.querySelectorAll(
                      ".product__media-list .swiper-wrapper .product__media img"
                    );

                    // If no images found, try alternative selectors
                    if (newImages.length === 0) {
                      // Try product card structure
                      newImages = productMedia.querySelectorAll(
                        ".product__media-list .swiper-wrapper img"
                      );
                    }

                    // If still no images, try a more generic approach
                    if (newImages.length === 0) {
                      newImages = productMedia.querySelectorAll("img");
                    }
                  }

                  console.log("Found newImages:", newImages);
                  console.log(
                    "Product media HTML structure:",
                    productMedia?.innerHTML
                  );

                  const swiperContainer = productWrapper.querySelector(
                    ".swiper-productCard .swiper-wrapper"
                  );

                  // replace badges
                  const newBadges =
                    productQuickBuy.querySelector(".product-badges");
                  if (newBadges) {
                    productWrapper.querySelector(
                      ".product-grid__badges"
                    ).innerHTML = newBadges.innerHTML;
                  }

                  //replace link
                  productWrapper.querySelector("a").href = context.productURL;

                  // replace main image
                  const firstImage = newImages[0];
                  const secondImage = newImages[1];
                  const mainImage = productWrapper.querySelector(
                    ".product-card__main-image .theme-img"
                  );
                  if (mainImage && firstImage) {
                    mainImage.srcset = firstImage.src;
                    mainImage.src = firstImage.src;
                  }
                  // Replace hover image (if exists, on homepage)
                  const hoverImage = productWrapper.querySelector(
                    ".product-card__image--secondary .theme-img"
                  );
                  if (hoverImage && secondImage && secondImage.src) {
                    hoverImage.srcset = secondImage.src;
                    hoverImage.src = secondImage.src;
                  }

                  // replace slider
                  // Create a DocumentFragment to batch updates for performance
                  if (newImages.length > 0) {
                    const fragment = document.createDocumentFragment();
                    newImages.forEach((item) => {
                      const slide = document.createElement("li");
                      slide.className = "swiper-slide";
                      const clonedImage = item.cloneNode(true);
                      slide.appendChild(clonedImage);
                      fragment.appendChild(slide);
                    });

                    if (swiperContainer) {
                      // Replace the current swiper-wrapper content with the new slides
                      swiperContainer.innerHTML = ""; // Clear the existing content
                      swiperContainer.appendChild(fragment);
                    }

                    if (productWrapper.swiper) {
                      // If Swiper instance exists, update it
                      productWrapper.swiper.update();
                    } else {
                      // Otherwise, initialize a new Swiper instance
                      const swiperOptions = {
                        slidesPerView: 1,
                        navigation: {
                          nextEl: ".swiper-button-next",
                          prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                          el: ".swiper-pagination",
                          clickable: true,
                        },
                        loop: true,
                        breakpoints: {
                          769: {
                            initialSlide: 1,
                          },
                        },
                      };
                      new Swiper(
                        productWrapper.querySelector(".swiper-productCard"),
                        swiperOptions
                      );
                    }
                  }
                }
              } else {
                const productWrapper = this.closest(
                  "[data-product-content-wrapper]"
                );
                const productMedia = html.querySelector("media-gallery"); // The media-gallery comes from the product-quick-buy component
                const currentProductMedia =
                  productWrapper.querySelector("media-gallery") ||
                  productWrapper.querySelector("product-media");

                if (productMedia && currentProductMedia)
                  currentProductMedia.replaceWith(productMedia);
              }
            }

            const currentElements = Array.from(
              this.querySelectorAll("[data-update-id]")
            );
            const newElements = Array.from(
              productQuickBuy.querySelectorAll("[data-update-id]")
            );
            // Update existing elements and track their order
            currentElements.forEach((currentElement) => {
              const currentUpdateId =
                currentElement.getAttribute("data-update-id");
              const newElement = productQuickBuy.querySelector(
                `[data-update-id="${currentUpdateId}"]`
              );
              if (newElement) {
                // Replace the element if it has the data-replace-content attribute, otherwise update the innerHTML
                if (
                  this.isGridItem &&
                  newElement.getAttribute("data-update-id") ===
                    "submit-buy_buttons"
                ) {
                  newElement.querySelector(
                    "span[data-add-to-cart-text]"
                  ).textContent = this.wording;
                }
                newElement.hasAttribute("data-replace-content")
                  ? currentElement.replaceWith(newElement)
                  : (currentElement.innerHTML = newElement.innerHTML);
              }
              // find in each element the input and the label to add to the id the value context.containerId
              const inputs = currentElement.querySelectorAll("input");
              const labels = currentElement.querySelectorAll("label");
              const scripts = currentElement.querySelectorAll("script");
              inputs.forEach((input) => {
                const inputId = input.getAttribute("id");
                const newId = inputId + "-" + context.containerId;
                input.setAttribute("name", newId);
                input.setAttribute("id", newId);
              });
              labels.forEach((label) => {
                label.setAttribute(
                  "for",
                  label.getAttribute("for") + "-" + context.containerId
                );
              });
              scripts.forEach((script) => {
                script.setAttribute(
                  "data-resource",
                  script.getAttribute("data-resource") +
                    "-" +
                    context.containerId
                );
              });
            });

            const swymWishlist = this.querySelector(".swym-button");
            if (swymWishlist) {
              const previousId = swymWishlist.getAttribute("data-product-id");
              swymWishlist.classList.remove(`product_${previousId}`);
              swymWishlist.classList.add(`product_${context.sectionId}`);
              swymWishlist.setAttribute("data-product-id", context.sectionId);
              swymWishlist.setAttribute("data-variant-id", context.variant.id);
              swymWishlist.setAttribute(
                "data-product-url",
                `https://stella-forest-shop.myshopify.com${context.fetchURL}`
              );
            }
            if (this.isGridItem) {
              this.openQuickBuy = this.querySelector(".quickAddJs");
              this.closeQuickBuy = this.querySelector(".quickAddCloseJs");
              if (this.openQuickBuy) {
                this.openQuickBuy.addEventListener(
                  "click",
                  this.openQuickBuyModal.bind(this)
                );
              }
              if (this.closeQuickBuy) {
                this.closeQuickBuy.addEventListener(
                  "click",
                  this.closeQuickBuyModal.bind(this)
                );
              }
            }
            if (!this.isGridItem) {
              // Add new elements in the correct order
              newElements.forEach((newElement) => {
                const newUpdateId = newElement.getAttribute("data-update-id");
                const existingElement = this.querySelector(
                  `[data-update-id="${newUpdateId}"]`
                );

                if (!existingElement) {
                  // Determine the correct position to insert the new element
                  let inserted = false;
                  for (let i = 0; i < currentElements.length; i++) {
                    const currentElement = currentElements[i];
                    const currentUpdateId =
                      currentElement.getAttribute("data-update-id");
                    if (currentUpdateId > newUpdateId) {
                      currentElement.insertAdjacentElement(
                        "beforebegin",
                        newElement.cloneNode(true)
                      );
                      inserted = true;
                      break;
                    }
                  }
                  // If not inserted, append to the end
                  if (!inserted) {
                    this.appendChild(newElement.cloneNode(true));
                  }
                }
              });
            }

            /*if (this.isCombinedListing && context.isCombinedListing) {
          const productWrapper = this.closest('[data-product-content-wrapper]');
          const productMedia = html.querySelector('product-media');
          const currentProductMedia = productWrapper?.querySelector('product-media');
          if (productMedia && currentProductMedia) currentProductMedia.replaceWith(productMedia);
        }*/

            if (window.Shopify && window.Shopify.PaymentButton) {
              window.Shopify.PaymentButton.init();
            }
          }
        }
      }
    );
  }
  /******/
})();
